export default {
  QUESTION: 'Question',
  QUESTION_TYPE: 'Question type',
  EMPTY_OPTIONS: 'Please provide an option values.',
  FILL_REQUIRED_VALUES: 'Please fill the required values.',
  DELETE_QUESTION_POPUP_TITLE: 'Delete question?',
  DELETE_QUESTION_POPUP_LABEL:
    'Once deleted the question will not be visible in the app and needs to be added again in case you want it back.',
  FORM_UPDATE_SUCCESS: 'Your form has been updated successfully!',
  CHOOSE_ANS_TYPE: 'Choose an answer type',
  SETUP_QUESTION: 'Setup qualifying questions',
  SETUP_QUESTION_INFO: 'Modify these questions to qualify your leads; changes will update in your app.',
  FIX_QUESTION_INFO: 'This question is mandatory in the app and can not be edited or changed.',
  NEW_QUESTION_BTN: 'Click here to add a new question'
}
